import React from 'react';
import SecurityIndicators from './SecurityIndicators';
import ExamTimer from './ExamTimer';

const ExamHeader = ({ 
  exam,
  currentQuestionIndex,
  questions,
  answeredCount,
  isFullscreen,
  cameraPermission,
  tabSwitchCount,
  timeLeft,
  timerType,
  questionTimeLeft,
  sectionTimeLeft,
  currentSection,
  formatTime
}) => {
  const progress = (answeredCount / questions.length) * 100;

  return (
    <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-3 py-2">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-sm font-semibold">{exam.name}</h1>
            <p className="text-xs text-indigo-100">Q {currentQuestionIndex + 1}/{questions.length}</p>
          </div>
          
          <div className="flex items-center gap-2">
            {/* Security Indicators */}
            <SecurityIndicators 
              isFullscreen={isFullscreen}
              cameraPermission={cameraPermission}
              tabSwitchCount={tabSwitchCount}
            />
            
            {/* Timer Display */}
            <ExamTimer 
              timeLeft={timeLeft}
              timerType={timerType}
              questionTimeLeft={questionTimeLeft}
              sectionTimeLeft={sectionTimeLeft}
              currentSection={currentSection}
              exam={exam}
              formatTime={formatTime}
            />
          </div>
        </div>

        {/* Progress Bar */}
        <div className="mt-2">
          <div className="flex justify-between text-xs text-indigo-100 mb-1">
            <span>{answeredCount}/{questions.length}</span>
            <span>{Math.round(progress)}%</span>
          </div>
          <div className="w-full bg-indigo-800 rounded-full h-1">
            <div 
              className="bg-white h-1 rounded-full transition-all duration-300"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamHeader;
